import AnnounceMent from "../../../../components/units/Edgecross/Announcement";

export default function AnnouncementPage() {
  return <AnnounceMent />;
}
